import { DAY_MS, formatDateISO } from '@elka/utils';

/**
 * Local-calendar YYYY-MM-DD. `toISOString().split('T')[0]` gives the UTC date,
 * which in Israel (UTC+2/3) is yesterday between local midnight and ~02:00–03:00 —
 * tasks would bucket into the wrong day group during that window. `formatDateISO`
 * formats from the Date object's local getters, so this stays on the local day.
 */
export function localDateStr(ms: number = Date.now()): string {
  return formatDateISO(new Date(ms));
}

/**
 * Hebrew relative-day label for a date relative to now, e.g. "היום", "אתמול",
 * "לפני 3 ימים", "בעוד יומיים". Day-granularity only (the CRM deals in due
 * dates and last-touch days, not hours). Returns null for a missing date.
 */
export function relativeDays(
  ms: number | null | undefined,
  now: number = Date.now()
): string | null {
  if (ms == null || !Number.isFinite(ms)) return null;
  // Compare calendar days, not raw 24h spans, so "today" stays "today" all day.
  const startOfDay = (t: number) => {
    const d = new Date(t);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
  };
  const diffDays = Math.round((startOfDay(ms) - startOfDay(now)) / DAY_MS);

  if (diffDays === 0) return 'היום';
  if (diffDays === -1) return 'אתמול';
  if (diffDays === 1) return 'מחר';
  if (diffDays === -2) return 'לפני יומיים';
  if (diffDays === 2) return 'בעוד יומיים';
  if (diffDays < 0) return `לפני ${Math.abs(diffDays)} ימים`;
  return `בעוד ${diffDays} ימים`;
}
